import { defineFcm } from '../shared/factory';

export const FCM_GROWTHBOOK_ENABLED = defineFcm('growthbook_enabled')
	.asBoolean()
	.withDefault(true)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Experiments (GrowthBook)',
		description: `Global integration-health switch for GrowthBook-backed experiments.

	When false, the middle-end forces every \`type: 'growthbook'\` experiment to its control variation
	(and typed fallback config), with no per-experiment change or deploy. It also stops each pod from
	talking to GrowthBook at all: the periodic payload fetch re-checks this flag on every tick and
	skips the network call while it's off, so an already-running pod stops polling GrowthBook, not
	just a freshly-booted one. Defaults to true.

	This is an escape hatch for when the GrowthBook SDK itself destabilizes pods, or when GrowthBook
	needs to be cut off entirely (incident response, vendor-access removal) — NOT a clean way to
	pause a single experiment. To pause one experiment with correct bucketing/exposure semantics, stop
	it in the GrowthBook dashboard instead. Exposure is deliberately not suppressed while this is off;
	exclude the disabled window in analysis instead.`,
		import: false,
	});
